// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jk-0";
export var fileCarousel = "_jk-2";
export var removeFileButton = "_jk-1";